module.exports = __webpack_public_path__ + "static/media/slewing-ring-bearing.e0d5e2fd.png";